(function () {
  'use strict';

  function initIgShop(scope) {
    var root = scope || document;

    root.querySelectorAll('[data-ig-shop]').forEach(function (section) {
      if (section.dataset.igInit === 'true') return;
      section.dataset.igInit = 'true';

      var items = Array.prototype.slice.call(section.querySelectorAll('[data-ig-item]'));
      var backdrop = section.querySelector('[data-popup-backdrop]');
      var sectionWrapper = section.closest('.shopify-section');
      var lastTrigger = null;
      var openItemRef = null;

      items.forEach(function (item) {
        var card = item.querySelector('[data-product-card]');
        if (card && !card._igPortalHome) {
          card._igPortalHome = document.createComment('ig-product-card-home');
          card.parentNode.insertBefore(card._igPortalHome, card);
        }
      });

      if (backdrop && !backdrop._igPortalHome) {
        backdrop._igPortalHome = document.createComment('ig-backdrop-home');
        backdrop.parentNode.insertBefore(backdrop._igPortalHome, backdrop);
      }

      function setWrapperState(isOpen) {
        section.classList.toggle('is-popup-open', isOpen);
        if (sectionWrapper) {
          sectionWrapper.classList.toggle('ig-shop-section-open', isOpen);
        }
      }

      function copyPopupVariables(card) {
        var styles = window.getComputedStyle(section);
        ['--ig-card-bg', '--ig-card-text', '--ig-muted', '--ig-card-radius'].forEach(function (name) {
          card.style.setProperty(name, styles.getPropertyValue(name));
        });
      }

      function moveToPortal(item) {
        var card = item.querySelector('[data-product-card]');
        if (!card) return;

        copyPopupVariables(card);
        card.dataset.igPortalOwner = section.id;
        document.body.appendChild(card);
        card.classList.add('ig-shop__card--portal');

        if (backdrop) {
          document.body.appendChild(backdrop);
          backdrop.classList.add('ig-shop__backdrop--portal');
        }

        return card;
      }

      function restorePortalNode(node, portalClass) {
        if (!node || !node._igPortalHome || !node._igPortalHome.parentNode) return;
        node.classList.remove(portalClass);
        if (node.dataset && node.dataset.igPortalOwner) delete node.dataset.igPortalOwner;
        node._igPortalHome.parentNode.insertBefore(node, node._igPortalHome.nextSibling);
      }

      function positionPortalCard(item, card) {
        if (!card) return;

        card.style.removeProperty('top');
        card.style.removeProperty('right');
        card.style.removeProperty('bottom');
        card.style.removeProperty('left');
        card.style.removeProperty('width');
        card.style.setProperty('--ig-card-shift', '0px');

        if (window.matchMedia('(max-width: 749px)').matches) return;

        var media = item.querySelector('.ig-shop__media');
        if (!media) return;

        var mediaRect = media.getBoundingClientRect();
        var safeEdge = 14;
        var cardWidth = Math.min(320, window.innerWidth - (safeEdge * 2));
        var desiredLeft = mediaRect.left + (mediaRect.width / 2) - (cardWidth / 2);
        var left = Math.max(safeEdge, Math.min(desiredLeft, window.innerWidth - cardWidth - safeEdge));

        card.style.width = cardWidth + 'px';
        card.style.left = left + 'px';
        card.style.top = Math.max(safeEdge, mediaRect.bottom - 38) + 'px';

        var cardHeight = card.offsetHeight;
        var highestTop = Math.max(safeEdge, window.innerHeight - cardHeight - safeEdge);
        var top = Math.min(Math.max(safeEdge, mediaRect.bottom - 38), highestTop);
        var arrowLeft = mediaRect.left + (mediaRect.width / 2) - left;

        card.style.top = top + 'px';
        card.style.setProperty('--ig-arrow-left', Math.max(22, Math.min(arrowLeft, cardWidth - 22)) + 'px');
      }

      function activePortalCard() {
        return Array.prototype.slice.call(document.body.querySelectorAll('.ig-shop__card--portal[data-product-card]'))
          .find(function (card) {
            return card.dataset.igPortalOwner === section.id;
          }) || null;
      }

      function closeAll(options) {
        var shouldRestoreFocus = options && options.restoreFocus;

        items.forEach(function (item) {
          item.classList.remove('is-active');

          var hotspot = item.querySelector('[data-hotspot]');
          var card = item.querySelector('[data-product-card]') || (openItemRef === item ? activePortalCard() : null);
          if (hotspot) hotspot.setAttribute('aria-expanded', 'false');
          if (card) {
            card.setAttribute('aria-hidden', 'true');
            card.classList.remove('is-open');
            card.style.setProperty('--ig-card-shift', '0px');
            restorePortalNode(card, 'ig-shop__card--portal');
          }
        });

        if (backdrop) {
          backdrop.classList.remove('is-open');
          restorePortalNode(backdrop, 'ig-shop__backdrop--portal');
        }

        setWrapperState(false);
        openItemRef = null;

        if (shouldRestoreFocus && lastTrigger) {
          lastTrigger.focus({ preventScroll: true });
        }
      }

      function openItem(item, hotspot) {
        var card = item.querySelector('[data-product-card]');
        if (!card) return;

        closeAll();
        card = moveToPortal(item);
        openItemRef = item;
        item.classList.add('is-active');
        card.classList.add('is-open');
        hotspot.setAttribute('aria-expanded', 'true');
        card.setAttribute('aria-hidden', 'false');
        if (backdrop) backdrop.classList.add('is-open');
        lastTrigger = hotspot;
        setWrapperState(true);

        window.requestAnimationFrame(function () {
          positionPortalCard(item, card);
        });
      }

      items.forEach(function (item) {
        var hotspot = item.querySelector('[data-hotspot]');
        var closeButton = item.querySelector('[data-popup-close]');
        var addButton = item.querySelector('[data-add-to-cart]');

        if (hotspot) {
          hotspot.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            if (item.classList.contains('is-active')) {
              closeAll({ restoreFocus: true });
            } else {
              openItem(item, hotspot);
            }
          });
        }

        if (closeButton) {
          closeButton.addEventListener('click', function (event) {
            event.preventDefault();
            closeAll({ restoreFocus: true });
          });
        }

        if (addButton) {
          addButton.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            var variantId = addButton.dataset.variantId;
            var label = addButton.querySelector('[data-add-label]');
            var originalLabel = label ? label.textContent : 'Add to cart';
            if (!variantId || addButton.disabled) return;

            addButton.disabled = true;
            if (label) label.textContent = 'Adding…';

            var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/';

            fetch(rootPath + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
            })
              .then(function (response) {
                if (!response.ok) throw new Error('Unable to add this product.');
                return response.json();
              })
              .then(function () {
                if (label) label.textContent = 'Added to cart';
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
              })
              .catch(function () {
                if (label) label.textContent = 'Please try again';
              })
              .finally(function () {
                window.setTimeout(function () {
                  addButton.disabled = false;
                  if (label) label.textContent = originalLabel;
                }, 1500);
              });
          });
        }
      });

      if (backdrop) {
        backdrop.addEventListener('click', function () {
          closeAll({ restoreFocus: true });
        });
      }

      document.addEventListener('click', function (event) {
        var portalCard = activePortalCard();
        var clickedInsideCard = portalCard && portalCard.contains(event.target);
        if (!section.contains(event.target) && !clickedInsideCard) closeAll();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && section.classList.contains('is-popup-open')) {
          closeAll({ restoreFocus: true });
        }
      });

      window.addEventListener('resize', function () {
        var portalCard = activePortalCard();
        if (openItemRef && portalCard) positionPortalCard(openItemRef, portalCard);
      });

      window.addEventListener('scroll', function () {
        var portalCard = activePortalCard();
        if (openItemRef && portalCard && !window.matchMedia('(max-width: 749px)').matches) {
          positionPortalCard(openItemRef, portalCard);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initIgShop(document);
    });
  } else {
    initIgShop(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initIgShop(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('[data-ig-shop]');
    var wrapper = section && section.closest('.shopify-section');
    if (wrapper) wrapper.classList.remove('ig-shop-section-open');
  });
})();
